// import { useState } from 'react'
import searchIcon from '../../assets/imgs/icons/search.svg'
import './style.scss'
// import QuickSearch from '../quickSearch/QuickSearch'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { setShowQuickSearchMobile } from '../../redux/reducers/searchSlice'

function MobileQuickSearch() {
	const showQuickSearchMobile = useAppSelector(state => state.search.showQuickSearchMobile)
	// const [showQuickSearchMenu, setShowQuickSearchMenu] = useState<boolean>(false)

	const dispatch = useAppDispatch()

	return (
		<div className="mobile-quick-search-wrap">
			<button className='mobile-quick-search-button' onClick={() => { dispatch(setShowQuickSearchMobile(!showQuickSearchMobile)) }}>
				<img
					src={searchIcon}
					className='mobile-quick-search-button-icon'
					alt='search button icon'
				/>
			</button>
			{/* {showQuickSearchMenu && <QuickSearch />} */}
		</div>
	)
}

export default MobileQuickSearch
